import React from "react";
import {useIntl} from "react-intl";
import {Location, PackageInfo} from "../model/rideInfo";
import {formatMoney} from "../model/moneyUtils";
import {ReactComponent as CodIcon} from "../image/cod-icon.svg";
import {ReactComponent as SenderIcon} from "../image/sender-icon.svg";
import {ReactComponent as DestinationIcon} from "../image/destination-icon.svg";
import {ReactComponent as CodeIcon} from "../image/code-icon.svg";

const shortenAddress = (address: string | undefined) => {
    if (address) {
        let addressArray: string[] = address.split(",");
        if (addressArray.length > 1) {
            addressArray.pop();
        }
        let shortAddress: string = addressArray.join(",");
        return shortAddress;
    }
};

export function SenderInfo({
    code,
    sender,
    destination,
}: {
    code: string | undefined;
    sender: PackageInfo;
    destination: Location;
}) {
    const intl = useIntl();
    return (
        <div className="sender-info">
            {code && (
                <span>
                    <CodeIcon />
                    <p className="code">{code}</p>
                </span>
            )}
            <span data-cy="sender-name">
                <SenderIcon />
                {sender.senderInfo?.name}
                {sender.itemCount != null &&
                    sender.itemCount > 1 &&
                    ` (${sender.itemCount} ${intl.formatMessage({id: "pcs"})})`}
            </span>

            <span data-cy="destination-address">
                <DestinationIcon />
                {shortenAddress(destination.placeName)}
            </span>

            {sender.collectOnDelivery && (
                <span className="cod-info" data-cy="shipment-collect-on-delivery">
                    <CodIcon className="cod-icon" />
                    {formatMoney(
                        {
                            amount: sender.collectOnDelivery.price.amount,
                            ccy: sender.collectOnDelivery.price.currency,
                        },
                        intl
                    )}
                </span>
            )}
        </div>
    );
}
